// En: paso-admin/src/services/ProjectService.ts

import { IProject } from "../types/Project";
import { apiClient } from "./apiClient";

/**
 * [READ] Obtiene todos los proyectos.
 */
export const getProjects = async (): Promise<IProject[]> => {
    try {
        return await apiClient('proyectos', { method: 'GET' });
    } catch (error) {
        console.error("Error al obtener proyectos:", error);
        throw error;
    }
};

/**
 * [READ ONE] Obtiene un proyecto por su ID.
 */
export const getProjectById = async (id: number): Promise<IProject | undefined> => {
    try {
        return await apiClient(`proyectos/${id}`, { method: 'GET' });
    } catch (error) {
        console.error("Error al obtener proyecto por ID:", error);
        return undefined;
    }
};

/**
 * [CREATE] Crea un nuevo proyecto.
 */
export const createProject = async (projectData: Omit<IProject, 'id'>): Promise<IProject> => {
    try {
        return await apiClient('proyectos', {
            method: 'POST',
            body: JSON.stringify(projectData),
        });
    } catch (error) {
        console.error("Error al crear proyecto:", error);
        throw error;
    }
};

/**
 * [UPDATE] Actualiza un proyecto existente.
 */
export const updateProject = async (projectData: IProject): Promise<IProject | undefined> => {
    try {
        const { id, ...updateData } = projectData as any;
        delete updateData.deletedAt;

        return await apiClient(`proyectos/${id}`, {
            method: 'PATCH',
            body: JSON.stringify(updateData),
        });
    } catch (error) {
        console.error("Error al actualizar el proyecto:", error);
        throw error;
    }
};

/**
 * [DELETE] Elimina un proyecto.
 */
export const deleteProject = async (id: number): Promise<boolean> => {
    try {
        await apiClient(`proyectos/${id}`, { method: 'DELETE' });
        return true;
    } catch (error) {
        console.error("Error al eliminar proyecto:", error);
        return false;
    }
};

// --- Funciones de Toggle ---

export const toggleProjectVisibility = async (id: number, isHidden: boolean): Promise<IProject | undefined> => {
    try {
        return await apiClient(`proyectos/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ isHidden }),
        });
    } catch (error) {
        console.error("Error al cambiar visibilidad:", error);
        throw error;
    }
};

export const toggleProjectFeatured = async (id: number, isFeatured: boolean): Promise<IProject | undefined> => {
    try {
        return await apiClient(`proyectos/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ isFeatured }),
        });
    } catch (error) {
        console.error("Error al cambiar estado de destacado:", error);
        throw error;
    }
};